import { render, staticRenderFns } from "./default-form.vue?vue&type=template&id=226b15be&scoped=true&"
import script from "./default-form.vue?vue&type=script&lang=js&"
export * from "./default-form.vue?vue&type=script&lang=js&"
import style0 from "./default-form.vue?vue&type=style&index=0&id=226b15be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226b15be",
  null
  
)

export default component.exports